const defaultWKO = {
  Authentication: {
    jwe: '',
    token: '',
    roles: 'user',
  },
  Locale: {
    country: 'DE',
    language: 'de',
  },
  Environment: {
    stageVariant: 'prod',
    country: 'DE',
    apiUri: 'https://api.oneweb.mercedes-benz.com',
    languageDirection: 'ltr',
    stage: 'PROD',
    language: 'de',
    experience: 'MBMXP',
    assetUri: 'https://assets.oneweb.mercedes-benz.com/plugin',
    wcmMode: 'DISABLED',
    runMode: 'PUBLISH',
  },
  DealerContext: null,
  ConsentList: [],
  User: {
    consent: {
      dataUsageScopes: [
        {
          name: 'SERVICEUSAGE',
          agreed: false,
        },
        {
          name: 'DATAFROM3RDPARTY',
          agreed: false,
        },
        {
          name: 'VEHICLEUSAGE',
          agreed: false,
        },
        {
          name: 'EMAILBEHAVIOUR',
          agreed: false,
        },
        {
          name: 'ONLINETRACKSM',
          agreed: false,
        },
      ],
      enableDataUsages: true,
    },
  },
};

const UserWithVehiclesAndDealer = {
  ...defaultWKO,
  User: {
    personal: {
      name: 'Test Test',
      firstname: 'Test',
      lastname: 'Test',
      email: 'test.test.tradein@mailinator.com',
      roles: 'user',
      phone: '+49 123 456789',
    },
    associatedVehicles: [
      {
        userId: '',
        finOrVin: 'W1K1770861J330670',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        licensePlate: 'WN-JR270E',
        modelDescription: 'A 250 e Kompaktlimousine',
        confirmed: true,
        imageUrl:
          'https://europe.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqNxFqtyO67PobzIr3eWsrrCsdRRzwQZg9pZbMw3SGtxX2tsd2sDcUfp8qXGEubXJ0l3ofOB2NbFbApj7pI5ux5xQC31SrkzNwt9m7jZ2IhKVFpE%25vqCv%25yLRzGHYax75SrH1KMdn8wvT4oiZLk1M4FaTuTg90gT6PDBPuSeWAe2tsd5HxcUfCXNXGEtiSJ0lLYqOB2agRbApHtXI5u8rIQC3UMOkzNG%25wm7j0cShKVBbh%25vqAIlyLR5SVYaxVbWrH1gIrn8wPQboiZeIQM6oY2ulLXkzNU%25dm7jsFI5Tj49QCbteDkzIfzWm7QRPdhKUV3f%25vGQBEyLYyPlYaruG2rHnFwpn8oKEuoiMvT3Mk5bHlqGeAN5ksQD494FNgiaSSszq7Pfg7jdKzAyAFiFX8QmcaJ86USQOEzWl89EK&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '1770861',
        bm7: '1770861',
        brand: '',
        preferredServiceDealerId: 'GS0000565',
        mileage: {
          value: '697',
          unit: 'km',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '6',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
      {
        userId: '',
        finOrVin: 'WDD2050781R489147',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        licensePlate: 'е898ао797',
        modelDescription: 'C 200 4MATIC',
        confirmed: true,
        imageUrl:
          'https://europe.stage.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqaxFqtyO67PobzIr3eWsrrCsdRRzwQZgk4ZbMw3SGtGyhtsd2sDcUfp8fXGEuiRJ0l3IJOB2NQnbApjtwI5uVQDQC31MTkzNwTVm7jZcohKVFXW%25vq9JlyLRzG6Yax70qrH1KMrn8wvTxoiZLqZM4FGIlTg90Qe6PDBPlSeWAyItsd5c3cUfCmfXGEtGmJ0lcHfOB2XQcbApJtRI5u8ezQC3iXOkzN4JKm7j06ShKVBYF%25vqAJ%25yLR5OXYaxCkYrH1zmin8w7h3oiZKMXM4FvTrTg9L6k6PDaG6SeWH0htsd8kDcUfAU0XGE5nYJ0lCrnOIJtR1qaWoiZC7lM4F84jTg9izk6PD4LbSeWgXhtsdPYVcUfx9wXGE0GjJ0lBHAOB2Mr1bA4wHEcmqN1IwClaMWLpnIu2fzzjFm93Su9Q6DF1s1n2nvligKfLlCVziatFTclotD&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '2050781',
        bm7: '2050781',
        brand: '',
        preferredServiceDealerId: '',
        mileage: {
          value: '',
          unit: '',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '5.5',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
      {
        userId: '',
        finOrVin: 'WDD1770031Z000041',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        modelDescription: 'A 180 d Kompaktlimousine',
        confirmed: true,
        imageUrl:
          'https://europe.stage.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqXWFqtyO67PobzIr3eWsrrCsdRRzwQZxkIZbMw3SGtlK9tsd2HtcUfp8qXGEui2J0l3IrOB2NMEbApjdRI5uVcZQC31MrkzNwzwm7jZcohKVFXW%25vqCUjyLRzGXYax7o8rH1KIRn8wvVnoiZUbEM4FGIJTg90gT6PDBPlSeWAtItsd6v3cUfSX6XGEvhmJ0lgYrOB2PBqbApeToI5uscIQC3UkTkzNGL6m7j0M3hKV3YQ%25vq8JcyLRiXJYnymdEWUNOB2GMnbAp5AXI5uC5MQC3zsFkzN7lbm7jK2fhKUWP3IrZxD%25WU1scDjVS%25qjuaa1frEROqEyJlfDADSjSiNsG8u4NLwasgbfXINtbl&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '1770031',
        bm7: '1770031',
        brand: '',
        preferredServiceDealerId: '',
        mileage: {
          value: '',
          unit: '',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '6',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
      {
        userId: '',
        finOrVin: 'W1N2533151F915558',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        modelDescription: 'GLC 220 d 4MATIC Coupé',
        confirmed: true,
        imageUrl:
          'https://europe.stage.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqahgqtyO67PobzIr3eWsrrCsdRRzwQZg9pZbMw3SGtle9tsd2HVcUfpOyXGEjyYJ0lVohOB2sQ5bApUdpI5uLoxQC3aCRkzNH%25um7j8cohKVk0Q%25vqm89yLRsGyYaxU58rH1Gm%25n8w0h4oiZKbXM4FvmQTg9LYT6PDarsSeWHnRtsd8cTcUfiANXGE45XJ0lg%25fOB2frqbAp7AXI5uK6YQC3vT6khQOZ9w4lSeWvantsdPHQcUfeOyXGEs9RJ0lU6xOB2Z5rbAp5nyI5uC5xQC3zCOkzN7P9m7sDgubYwR9hDvV9BTCj6hVNpLLxdYfqJVf%25XEd9B96N683eUHpi3v1Le4Odcb3SOE&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '2533151',
        bm7: '2533151',
        brand: '',
        preferredServiceDealerId: '',
        mileage: {
          value: '',
          unit: '',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '6',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
      {
        userId: '',
        finOrVin: 'W1N2476151W094894',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        modelDescription: 'GLB 220 d 4MATIC',
        confirmed: true,
        imageUrl:
          'https://europe.stage.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqNEFqtyO67PobzIr3eWsrrCsdRRzwQZg9BZbMw3SGtle9tsd2HVcUfpOyXGEjGjJ0lVohOB2s85bApUkCI5uG62QC3aM1kzNHzxm7j8y3hKVi%25F%25vqmBkyLRsGfYaxU5drH1Gm%25n8w0hEoiZBJZM4FvIJTg9LtV6PDa%256SeWHyhtsd8otcUfiM1XGE4JYJ0lgCVOB2PyEbApETRI5uK6MQC3vT6khQOZ9w4lSeWawMtsdLYqcUfeOyXGE1FyJ0lBHtOB2A81bAp5iCI5uC6MQC3zEOkze94pOy1qFm9KWPpM5NTmj32vvRWydVXjdhcfWF0FT3THuPsa28uKxvPiJWtOu6Jf&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '2476151',
        bm7: '2476151',
        brand: '',
        preferredServiceDealerId: '',
        mileage: {
          value: '',
          unit: '',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '6',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
    ],
    selectedAssociatedVehicle: {
      finOrVin: undefined,
    },
    selectedAssociatedDealer: {
      salesDealer: {
        outletId: 'GS0000565',
        legalName: 'Autohaus Lorinser GmbH & Co. KG',
        address: {
          city: 'Waiblingen',
          isoCode: 'DE',
          street: 'Alte Bundesstraße',
          streetNumber: '45',
          zipCode: '71332',
        },
        communication: {
          general: {
            phone: '+49 7151 1360',
            facebook: 'https://www.facebook.com/autohaus.lorinser/',
            instagram: 'https://www.instagram.com/autohauslorinser/',
            fax: '+49 7151 136 2880',
            email: 'info@lorinser.com',
            internet: 'https://www.mercedes-benz-lorinser.de',
          },
        },
        dealerType: 'SALES',
      },
      serviceDealer: {
        outletId: 'GS0000565',
        legalName: 'Autohaus Lorinser GmbH & Co. KG',
        address: {
          city: 'Waiblingen',
          isoCode: 'DE',
          street: 'Alte Bundesstraße',
          streetNumber: '45',
          zipCode: '71332',
        },
        communication: {
          general: {
            phone: '+49 7151 1360',
            facebook: 'https://www.facebook.com/autohaus.lorinser/',
            instagram: 'https://www.instagram.com/autohauslorinser/',
            fax: '+49 7151 136 2880',
            email: 'info@lorinser.com',
            internet: 'https://www.mercedes-benz-lorinser.de',
          },
        },
        dealerType: 'SERVICE',
      },
    },
    associatedDealers: {
      W1K1770861J330670: [
        {
          outletId: 'GS0000565',
          legalName: 'Autohaus Lorinser GmbH & Co. KG',
          address: {
            city: 'Waiblingen',
            isoCode: 'DE',
            street: 'Alte Bundesstraße',
            streetNumber: '45',
            zipCode: '71332',
          },
          communication: {
            general: {
              phone: '+49 7151 1360',
              facebook: 'https: //www.facebook.com/autohaus.lorinser/',
              instagram: 'https: //www.instagram.com/autohauslorinser/',
              fax: '+49 7151 136 2880',
              email: 'info@lorinser.com',
              internet: 'https: //www.mercedes-benz-lorinser.de',
            },
          },
          dealerType: 'SALES',
        },
        {
          outletId: 'GS0000565',
          legalName: 'Autohaus Lorinser GmbH & Co. KG',
          address: {
            city: 'Waiblingen',
            isoCode: 'DE',
            street: 'Alte Bundesstraße',
            streetNumber: '45',
            zipCode: '71332',
          },
          communication: {
            general: {
              phone: '+49 7151 1360',
              facebook: 'https: //www.facebook.com/autohaus.lorinser/',
              instagram: 'https: //www.instagram.com/autohauslorinser/',
              fax: '+49 7151 136 2880',
              email: 'info@lorinser.com',
              internet: 'https: //www.mercedes-benz-lorinser.de',
            },
          },
          dealerType: 'SERVICE',
        },
      ],
    },
  },
};

const UserWithOneSelectedVehicleAndOneDealer = {
  ...defaultWKO,
  User: {
    personal: {
      name: 'Test Test',
      firstname: 'Test',
      lastname: 'Test',
      email: 'test.test.tradein@mailinator.com',
      roles: 'user',
      phone: '+49 123 456789',
    },
    associatedVehicles: [
      {
        userId: '',
        finOrVin: 'W1K1770861J330670',
        vehicleConnectivityCapability: 'CONNECT_VEHICLE',
        licensePlate: 'WN-JR270E',
        modelDescription: 'A 250 e Kompaktlimousine',
        confirmed: true,
        imageUrl:
          'https://europe.starconnect-ce.i.daimler.com/iris/iris.png?COSY-EU-100-1713d0VXqNxFqtyO67PobzIr3eWsrrCsdRRzwQZg9pZbMw3SGtxX2tsd2sDcUfp8qXGEubXJ0l3ofOB2NbFbApj7pI5ux5xQC31SrkzNwt9m7jZ2IhKVFpE%25vqCv%25yLRzGHYax75SrH1KMdn8wvT4oiZLk1M4FaTuTg90gT6PDBPuSeWAe2tsd5HxcUfCXNXGEtiSJ0lLYqOB2agRbApHtXI5u8rIQC3UMOkzNG%25wm7j0cShKVBbh%25vqAIlyLR5SVYaxVbWrH1gIrn8wPQboiZeIQM6oY2ulLXkzNU%25dm7jsFI5Tj49QCbteDkzIfzWm7QRPdhKUV3f%25vGQBEyLYyPlYaruG2rHnFwpn8oKEuoiMvT3Mk5bHlqGeAN5ksQD494FNgiaSSszq7Pfg7jdKzAyAFiFX8QmcaJ86USQOEzWl89EK&&BKGND=9&IMGT=P27&POV=BE040,PZM&width=1000&crop=0,256,1920,870&uni=c',
        modelId: '1770861',
        bm7: '1770861',
        brand: '',
        preferredServiceDealerId: 'GS0000565',
        mileage: {
          value: '697',
          unit: 'km',
        },
        trustLevel: '',
        userRole: 'VEHICLE_OWNER',
        status: 'VALID',
        connectAndConfirmedVehicle: true,
        vehicleOwner: true,
        vehicleUsageCode: '',
        complete: true,
        pinRequired: false,
        ntg: '6',
        vehicleName: '',
        isConfirmed: true,
        isConnectAndConfirmedVehicle: true,
        isVehicleOwner: true,
        isComplete: true,
        isPinRequired: false,
        ps: ['RD_SS', 'DE_OR_AS', 'DE_OR_AN', 'IE_US', 'ME_SS_DR', 'ME_SE_DR', 'ME_SM_PN', 'ME_VE_DA'],
      },
    ],
    selectedAssociatedVehicle: {
      finOrVin: 'W1K1770861J330670',
    },
    selectedAssociatedDealer: {
      salesDealer: {
        outletId: 'GS0000565',
        legalName: 'Autohaus Lorinser GmbH & Co. KG',
        address: {
          city: 'Waiblingen',
          isoCode: 'DE',
          street: 'Alte Bundesstraße',
          streetNumber: '45',
          zipCode: '71332',
        },
        communication: {
          general: {
            phone: '+49 7151 1360',
            facebook: 'https://www.facebook.com/autohaus.lorinser/',
            instagram: 'https://www.instagram.com/autohauslorinser/',
            fax: '+49 7151 136 2880',
            email: 'info@lorinser.com',
            internet: 'https://www.mercedes-benz-lorinser.de',
          },
        },
        dealerType: 'SALES',
      },
      serviceDealer: {
        outletId: 'GS0000565',
        legalName: 'Autohaus Lorinser GmbH & Co. KG',
        address: {
          city: 'Waiblingen',
          isoCode: 'DE',
          street: 'Alte Bundesstraße',
          streetNumber: '45',
          zipCode: '71332',
        },
        communication: {
          general: {
            phone: '+49 7151 1360',
            facebook: 'https://www.facebook.com/autohaus.lorinser/',
            instagram: 'https://www.instagram.com/autohauslorinser/',
            fax: '+49 7151 136 2880',
            email: 'info@lorinser.com',
            internet: 'https://www.mercedes-benz-lorinser.de',
          },
        },
        dealerType: 'SERVICE',
      },
    },
    associatedDealers: {
      W1K1770861J330670: [
        {
          outletId: 'GS0000565',
          legalName: 'Autohaus Lorinser GmbH & Co. KG',
          address: {
            city: 'Waiblingen',
            isoCode: 'DE',
            street: 'Alte Bundesstraße',
            streetNumber: '45',
            zipCode: '71332',
          },
          communication: {
            general: {
              phone: '+49 7151 1360',
              facebook: 'https: //www.facebook.com/autohaus.lorinser/',
              instagram: 'https: //www.instagram.com/autohauslorinser/',
              fax: '+49 7151 136 2880',
              email: 'info@lorinser.com',
              internet: 'https: //www.mercedes-benz-lorinser.de',
            },
          },
          dealerType: 'SALES',
        },
      ],
    },
  },
};

const UserWithInvalidVehicleAndInvalidDealer = {
  ...defaultWKO,
  User: {
    personal: {
      name: undefined,
      firstname: undefined,
      lastname: undefined,
      email: undefined,
      roles: undefined,
      phone: undefined,
    },
    associatedVehicles: [
      {
        userId: undefined,
        finOrVin: undefined,
        vehicleConnectivityCapability: undefined,
        licensePlate: undefined,
        modelDescription: undefined,
        confirmed: undefined,
        imageUrl: undefined,
        modelId: undefined,
        bm7: undefined,
        brand: undefined,
        preferredServiceDealerId: undefined,
        mileage: {
          value: undefined,
          unit: undefined,
        },
        trustLevel: undefined,
        userRole: undefined,
        status: undefined,
        connectAndConfirmedVehicle: undefined,
        vehicleOwner: undefined,
        vehicleUsageCode: undefined,
        complete: undefined,
        pinRequired: undefined,
        ntg: undefined,
        vehicleName: undefined,
        isConfirmed: undefined,
        isConnectAndConfirmedVehicle: undefined,
        isVehicleOwner: undefined,
        isComplete: undefined,
        isPinRequired: undefined,
        ps: [],
      },
    ],
    selectedAssociatedVehicle: {
      finOrVin: undefined,
    },
    selectedAssociatedDealer: {
      salesDealer: {
        outletId: undefined,
        legalName: undefined,
        address: {
          city: undefined,
          isoCode: undefined,
          street: undefined,
          streetNumber: undefined,
          zipCode: undefined,
        },
        communication: {
          general: {
            phone: undefined,
            facebook: undefined,
            instagram: undefined,
            fax: undefined,
            email: undefined,
            internet: undefined,
          },
        },
        dealerType: undefined,
      },
      serviceDealer: {
        outletId: undefined,
        legalName: undefined,
        address: {
          city: undefined,
          isoCode: undefined,
          street: undefined,
          streetNumber: undefined,
          zipCode: undefined,
        },
        communication: {
          general: {
            phone: undefined,
            facebook: undefined,
            instagram: undefined,
            fax: undefined,
            email: undefined,
            internet: undefined,
          },
        },
        dealerType: undefined,
      },
    },
    associatedDealers: {
      W1K1770861J330670: [
        {
          outletId: undefined,
          legalName: undefined,
          address: {
            city: undefined,
            isoCode: undefined,
            street: undefined,
            streetNumber: undefined,
            zipCode: undefined,
          },
          communication: {
            general: {
              phone: undefined,
              facebook: undefined,
              instagram: undefined,
              fax: undefined,
              email: undefined,
              internet: undefined,
            },
          },
          dealerType: undefined,
        },
      ],
    },
  },
};

const UserWithoutVehiclesAndDealer = {
  ...defaultWKO,
  User: {
    personal: {
      name: 'Test Test',
      firstname: 'Test',
      lastname: 'Test',
      email: 'test.test.tradein@mailinator.com',
      roles: 'user',
      phone: '+49 123 456789',
    },
    associatedVehicles: [],
  },
};

const mockTypes = [
  { type: 'User with multiple vehicles and dealer', data: UserWithVehiclesAndDealer },
  { type: 'User with one (selected) vehicle and one dealer', data: UserWithOneSelectedVehicleAndOneDealer },
  { type: 'User without vehicles and dealer', data: UserWithoutVehiclesAndDealer },
  { type: 'User with invalid vehicle and invalid dealer', data: UserWithInvalidVehicleAndInvalidDealer },
];

export { mockTypes };
